import { parseTime, createTimeObject } from "../support/helpers";
import $createCountdownTimer from "../timer/countdowntimer";

import {
  callback,
  isPlainObject,
  objectWithAccessors,
  withProperties
} from "../../utils";

export default function createCountdownTimer(options) {
  let $timer, current, {
    duration,
    onClear,
    onContinue,
    onExtend,
    onFinish,
    onHalt,
    onStart,
    onTick
  } = isPlainObject(options) ? options : {};

  duration = createTimeObject(duration);
  onClear = callback(onClear);
  onContinue = callback(onContinue);
  onExtend = callback(onExtend);
  onFinish = callback(onFinish);
  onHalt = callback(onHalt);
  onStart = callback(onStart);
  onTick = callback(onTick);
  
  function __onTick__(time) {
    onTick(current = createTimeObject(time));
  }

  function __onFinish__() {
    ($timer = undefined, onFinish());
  }

  const $timerPrototype = Object.freeze(withProperties(Object.create(null), {
    clear() {
      let cleared = false;

      try {
        cleared = Boolean(isPlainObject(this.$timer) && this.$timer.stop());
        cleared && ($timer = undefined, current = null, onClear());
      } finally { return cleared }
    },

    extend(duration) {
      let extended = false;

      try {
        duration = Math.min(parseTime(Math.ceil(duration)), this.duration.time);
        extended = Boolean(isPlainObject(this.$timer) && duration && (duration = this.$timer.extend(duration)));
        extended && onExtend(createTimeObject(duration));
      } catch (e) { console.error(e) } finally { return extended }
    },

    halt() {
      let halted = false;

      try {
        halted = Boolean(isPlainObject(this.$timer) && this.$timer.pause());
        halted && onHalt();
      } finally { return halted }
    },

    start() {
      let started = false;
      let startCallback = onStart;

      if (isPlainObject(this.$timer)) {
        if (this.$timer.ticking) return false;
        startCallback = onContinue;
      } else {
        $timer = $createCountdownTimer({ callback: __onFinish__, duration: this.duration.time });
        $timer.addTickCallback(__onTick__);
      }

      try {
        started = Boolean(this.$timer.play());
        started && startCallback();
      } finally { return started }
    }
  }));

  return Object.freeze(
    objectWithAccessors.call(Object.create($timerPrototype), {
      $timer: () => $timer,
      current: () => current,
      duration: () => duration
    })
  );
}
